import React, { useState } from 'react';
import { useLang } from '../i18n';

// Pill toggle EN ↔ VI. Hover thì elevate (shadow + lift).
// 2 mode:
//   - default (inline=false): position:fixed top-center, dùng cho Login (không có topbar)
//   - inline=true: flex child không fixed, dùng embed trong topbar customer
export default function LanguageToggle({ top = 10, inline = false }) {
  const { lang, setLang } = useLang();
  const [hover, setHover] = useState(false);

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: 4,
    background: 'var(--bg-secondary)',
    border: '1px solid var(--border-strong)',
    borderRadius: 999,
    boxShadow: hover
      ? '0 8px 24px rgba(15,23,42,0.12), 0 2px 6px rgba(15,23,42,0.06)'
      : '0 2px 6px rgba(15,23,42,0.06)',
    transition: 'box-shadow 180ms, transform 180ms, border-color 180ms',
    cursor: 'default',
    userSelect: 'none',
  };

  const positionStyle = inline
    ? { transform: hover ? 'translateY(-2px)' : 'translateY(0)' }
    : {
        position: 'fixed',
        top,
        left: '50%',
        zIndex: 300,
        transform: hover ? 'translate(-50%, -2px)' : 'translate(-50%, 0)',
      };

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ ...baseStyle, ...positionStyle }}
    >
      <span style={{
        fontSize: 13, lineHeight: 1, padding: '0 4px 0 8px',
        opacity: 0.55, pointerEvents: 'none',
      }}>🌐</span>
      <Segment active={lang === 'en'} onClick={() => setLang('en')}>EN</Segment>
      <Segment active={lang === 'vi'} onClick={() => setLang('vi')}>VI</Segment>
    </div>
  );
}

function Segment({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        border: 'none',
        outline: 'none',
        cursor: active ? 'default' : 'pointer',
        background: active ? 'var(--accent)' : 'transparent',
        color: active ? '#052e16' : 'var(--text-secondary)',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.04em',
        padding: '6px 12px',
        borderRadius: 999,
        transition: 'background 160ms, color 160ms',
      }}
      onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'var(--bg-elevated)'; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
    >
      {children}
    </button>
  );
}
